import { RightOutlineIcon } from '@carboncopyco/icons';
import { ColorHex } from '../../constants';
import { TextCaption } from '../Typography';

export interface BreadcrumbsProps {
  links: { onClick: () => void; label: string }[];
  current: string;
}

export const Breadcrumbs = ({ current, links }: BreadcrumbsProps) => {
  return (
    <ul className="flex items-center gap-1.5">
      {links.map(({ onClick, label }, index) => {
        return (
          <li
            className="flex items-end cursor-pointer gap-1.5"
            onClick={onClick}
            key={`${index}${label}`}
          >
            <div className="max-w-[180px] truncate text-ds-natural-300">
              <TextCaption
                color="text-ds-natural-300"
                label={label}
              />
            </div>
            <div className="mb-0.5">
              <RightOutlineIcon
                size={16}
                color={ColorHex.natural300}
              />
            </div>
          </li>
        );
      })}
      <li
        className="max-w-[180px] truncate text-ds-natural-200"
        key="current-page"
      >
        <TextCaption
          color="text-ds-natural-200"
          label={current}
        />
      </li>
    </ul>
  );
};
